import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["trackStyle", "handleStyle"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import Slider from 'rc-slider';
import { jsx as _jsx } from "react/jsx-runtime";
export var InputSlider = /*#__PURE__*/memo(function (_ref) {
  var trackStyle = _ref.trackStyle,
      handleStyle = _ref.handleStyle,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Slider, _objectSpread({
    trackStyle: trackStyle || defaultTrackStyle,
    handleStyle: handleStyle || [defaultDotStyle, defaultDotStyle],
    "data-cy": "input-slider"
  }, rest));
});
export default InputSlider;
var defaultDotStyle = {
  backgroundColor: 'white',
  height: 16,
  width: 16,
  bordercolor: "#693eb5",
  opacity: 1,
  boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)"
};
var defaultTrackStyle = [{
  backgroundColor: "#693eb5"
}];